/*
 * Copyright 2025 Intuition Robotics ltd
 */
import type {DB_Object} from "@intuitionrobotics/ts-common";

// I don't feel comfortable writing this
// export type PatientGender = "m" | "f";
export enum PatientGender {
    MALE = "m",
    FEMALE = "f"
}

export enum UserRole {
    CareManager = "CareManager",
    Physician = "Physician",
    CaseManager = "CaseManager",
}

export type DB_User = DB_Object & {
    mail: string
    roles?: UserRole[]
    first: string
    last: string
    title?: string
    gender?: PatientGender
    permissionId?: string,
    mailEnabled?: boolean,
    created?: number
}

export const capitalize = (text: string) => {
    if (!text)
        return text;

    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

export const extractNameFromEmail = (email: string) => {
    const name = email.split('@')[0];
    return capitalize(name);
};

export const getDisplayName = (last: string, title?: string) => `${title || ''} ${last}`.trim();

export const getUserNameWithTitle = (user: DB_User) => {
    if (user.last)
        return getDisplayName(user.last, user.title);

    return extractNameFromEmail(user.mail);
};

